import React from 'react'

import { Translate } from '@hozana/intl/Translate'

import { Link } from 'elements/text/Link'
import { P } from 'elements/text/P'

import { PAGE } from 'routes/constants'

const CguLink: TFCC = ({ children }) => (
  <Link key="link" color="yellow" to={{ pathname: PAGE.STATIC, query: { pageSlug: 'cgu' } }}>
    {children}
  </Link>
)

export const Cgu: TFC<{ text: string }> = ({ text }) => (
  <P fontSize="0.8em" color="black50" align="center" lineHeight="1.6em" p="3px 7px">
    <Translate
      components={{
        linkTag: <CguLink />,
      }}
    >
      {text}
    </Translate>
  </P>
)
